
export class PrescricaoPDFsMesParmDTO {
  idUnidade: number;
  idPaciente: number;
  idMedico: number;
  mesAno: string;
  formato: string;
}